import { render, staticRenderFns } from "./LeafBox.vue?vue&type=template&id=c849438e&scoped=true&"
import script from "./LeafBox.vue?vue&type=script&lang=js&"
export * from "./LeafBox.vue?vue&type=script&lang=js&"
import style0 from "./LeafBox.vue?vue&type=style&index=0&id=c849438e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c849438e",
  null
  
)

export default component.exports